import { z } from 'zod';
import { PlaceTitleSchema } from '../../../renderer/src/place-title';

/** Draft text may be empty while the user edits; only complete titles reach capture. */
export const PlaceTitleSettingsSchema = z.object({
  enabled: z.boolean(), name: z.string().max(120), region: z.string().max(120),
  lookup: z.enum(['pending', 'resolved', 'unavailable', 'custom']).optional(),
}).strict();
export type PlaceTitleSettings = z.infer<typeof PlaceTitleSettingsSchema>;
export const emptyPlaceTitle = (): PlaceTitleSettings => ({ enabled: false, name: '', region: '' });
export const automaticPlaceTitle = (): PlaceTitleSettings => ({ enabled: true, name: '', region: '', lookup: 'pending' });

export function applyStartingPlaceTitle(settings: PlaceTitleSettings, title: { name: string; region: string }): PlaceTitleSettings {
  return settings.lookup === 'pending' ? { ...title, enabled: true, lookup: 'resolved' } : settings;
}

export function unavailableStartingPlace(settings: PlaceTitleSettings): PlaceTitleSettings {
  return settings.lookup === 'pending' ? { ...settings, enabled: !!settings.name.trim() && settings.enabled, lookup: 'unavailable' } : settings;
}

export function placeTitleForExport(settings: PlaceTitleSettings) {
  if (!settings.enabled) return undefined;
  const parsed = PlaceTitleSchema.safeParse({ name: settings.name, region: settings.region });
  return parsed.success ? parsed.data : undefined;
}
